// extracted by mini-css-extract-plugin
module.exports = {"duplicate_instance_modal":"BraqBPfNFQ0-OceRlaYmT","modal_title":"_2ZEvMLMKi4c6mcDQyLI1q6","modal_content":"_7cSGqci6oH-JksHhIfcvf"};